import Image from 'next/image'

const FeaturesSection = ({ image, imageAlt, heading, description }) => {
    return (
        <div className='mx-auto flex max-w-[1750px] items-center justify-center bg-white py-10 px-10 lg:py-20 lg:px-20'>
            <div className='flex flex-col-reverse justify-between gap-10 md:flex-row'>
                <div className='flex items-center justify-center md:w-[40%]'>
                    <div className='relative w-full overflow-hidden rounded-tr-[168px] lg:rounded-tr-[168px]'>
                        <Image
                            src='/Ai-Consultation/bg1.png'
                            alt='bg'
                            width={600}
                            height={400}
                            className='h-auto w-full object-contain'
                        />
                        <div className='absolute inset-0 bg-[linear-gradient(0deg,_rgba(30,58,138,0.7)_0%,_rgba(0,0,0,0)_100%)]'></div>
                    </div>
                </div>
                <div className='flex flex-col justify-center gap-y-4 md:w-[45%] lg:gap-y-10'>
                    <h2 className='font-inter w-full text-2xl font-bold leading-tight text-[#172554] lg:text-4xl lg:leading-[130%]'>
                        {heading}
                    </h2>
                    <div>
                        <p className='w-[90%] text-sm font-normal text-[#686868] lg:text-lg lg:leading-7'>
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeaturesSection
